import Utils from '../common/Utils';
import FooterPlaync from './components/footerPlaync';

class App {
    constructor(_config = {}) {
        this.footer = new FooterPlaync(_config);
    }
}

Utils.namespace('ncui.footer');
let ncuiFooter = new App();
